import { Link, useHistory } from "react-router-dom";
import "./Work.css";
import project1 from "../../Projects/PROJECT 1.png";
import project2 from "../../Projects/PROJECT 2.png";
import project3 from "../../Projects/PROJECT 3.png";
import project4 from "../../Projects/PROJECT 4.png";
import project5 from "../../Projects/PROJECT 5.png";
import project6 from "../../Projects/PROJECT 6.png";
import gsap from "gsap";
import { useEffect } from "react";
var Work = function () {
  useEffect(() => {
    const tl = gsap.timeline();
    tl.from(".wordOUT", { duration: 1, opacity: 0, y: "-100%" }, 1);
    tl.from(".wordMAIN", { duration: 1, opacity: 0, y: "100%" }, 1);
    tl.from(".projectImagesContainer", {
      duration: 1,
      opacity: 0,
      y: "100%",
      stagger: 0.2,
    });
  }, []);
  const history = useHistory();
  const moveToProjects = (which) => {
    history.push(`/work/${which}`);
  }
  return (
    <div>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Work</title>
      <link
        rel="stylesheet"
        type="text/css"
        id="applicationStylesheet"
        href="Work.css"
      />
      <div id="Work">
        <div id="menu">
          <div id="menu_text">
            <span className="menuItems">
              <Link to="/">Home</Link>
            </span>
            <span className="menuItems">
              <Link to="/about">About</Link>
            </span>
            <span className="menuItems" style={{ fontSize: "2rem" }}>
              <Link to="/work">Works</Link>
            </span>
            <span className="menuItems">
              <Link to="/contact">Contact</Link>
            </span>
          </div>
        </div>
        <div id="Work_be">
          <span className="wordOUT">Work</span>
          <span className="wordMAIN">Work</span>
          <span className="wordOUT">Work</span>
        </div>

        <div id="Projects">
          <div className="projectBlocks">


            <div className="projectImagesContainer" onClick={() => { moveToProjects(1) }} >
              <div
                style={{ backgroundImage: `url("${project1}")` }}
                className="projectImages"
              ></div>
            </div>


            <div className="projectImagesContainer" onClick={() => { moveToProjects(2) }} >
              <div
                style={{ backgroundImage: `url("${project2}")` }}
                className="projectImages"
              ></div>
            </div>


            <div className="projectImagesContainer" onClick={() => { moveToProjects(3) }} >
              <div
                style={{ backgroundImage: `url("${project3}")` }}
                className="projectImages"
              ></div>
            </div>

          </div>
          <div className="projectBlocks">

            <div className="projectImagesContainer" onClick={() => { moveToProjects(4) }} >
              <div
                style={{ backgroundImage: `url("${project4}")` }}
                className="projectImages"
              ></div>
            </div>


            <div className="projectImagesContainer" onClick={() => { moveToProjects(5) }} >
              <div
                style={{ backgroundImage: `url("${project5}")` }}
                className="projectImages"
              ></div>
            </div>


            <div className="projectImagesContainer" onClick={() => { moveToProjects(6) }} >
              <div
                style={{ backgroundImage: `url("${project6}")` }}
                className="projectImages"
              ></div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};
export default Work;
